export default {"src":"/_next/static/media/account-logout.617a8cea.svg","height":165,"width":276};